import axios from "axios";
import { AuthProvider } from "./../AuthProvider";

const graphUrl = "https://graph.microsoft.com/v1.0";

const getPhoto = async () => {
  var accessToken = "";
  const accessTokenRequest = {
    scopes: ["user.read"],
  };

  try {
    accessToken = await (
      await AuthProvider.acquireTokenSilent(accessTokenRequest)
    ).accessToken;
  } catch (error) {
    accessToken = await (
      await AuthProvider.acquireTokenPopup(accessTokenRequest)
    ).accessToken;
  }

  return await axios.get(`${graphUrl}/me/photos/48x48/$value`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    responseType: "arraybuffer",
  });
};

const getUserPhoto = async (userId: string) => {
  var accessToken = "";
  const accessTokenRequest = {
    scopes: ["user.read"],
  };

  try {
    accessToken = await (
      await AuthProvider.acquireTokenSilent(accessTokenRequest)
    ).accessToken;
  } catch (error) {
    accessToken = await (
      await AuthProvider.acquireTokenPopup(accessTokenRequest)
    ).accessToken;
  }

  return await axios.get(`${graphUrl}/users/${userId}/photo/$value`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    responseType: "arraybuffer",
  });
};

const getUserTitle = async () => {
  var accessToken = "";
  const accessTokenRequest = {
    scopes: ["user.read"],
  };

  try {
    accessToken = await (
      await AuthProvider.acquireTokenSilent(accessTokenRequest)
    ).accessToken;
  } catch (error) {
    accessToken = await (
      await AuthProvider.acquireTokenPopup(accessTokenRequest)
    ).accessToken;
  }

  return await axios.get(`${graphUrl}/me`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const getUserGroups = async () => {
  var accessToken = "";
  const accessTokenRequest = {
    scopes: ["user.read"],
  };

  try {
    accessToken = await (
      await AuthProvider.acquireTokenSilent(accessTokenRequest)
    ).accessToken;
  } catch (error) {
    accessToken = await (
      await AuthProvider.acquireTokenPopup(accessTokenRequest)
    ).accessToken;
  }

  return await axios.get(`${graphUrl}/me/memberOf`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const graphApi = {
  getPhoto,
  getUserPhoto,
  getUserTitle,
  getUserGroups,
};
